import httpClient from './httpClient';

const readTokenFromCookie = (): string | null => {
  const match = document.cookie.split(';').find(c => c.trim().startsWith('XSRF-TOKEN='));
  if (!match) return null;
  return decodeURIComponent(match.split('=')[1]);
};

let pendingToken: Promise<string> | null = null;

const requestToken = (): Promise<string> => {
  if (pendingToken) return pendingToken;
  pendingToken = (async () => {
    await httpClient.get('/auth/csrf', {
      headers: { 'Cache-Control': 'no-cache' },
    });
    const token = readTokenFromCookie();
    if (!token) throw new Error('The server did not issue a CSRF token.');
    return token;
  })().finally(() => { pendingToken = null; });
  return pendingToken;
};

export const ensureCsrfCookie = async (): Promise<string> => {
  const cookieToken = readTokenFromCookie();
  if (cookieToken) {
    return cookieToken;
  }
  return requestToken();
};

export const refreshCsrfToken = async (): Promise<string> => requestToken();
